<template>
  <div class="modal warning fade" :class="{ 'is-open': open }">
    <div class="modal-dialog modal-sm"   style="margin: 12% auto;"  >
      <div class="modal-content">
        <div class="modal-body">
          <div class="warning d-flex justify-content-start">
            <img
              width="48"
              :src="`${BaseUrl}assets/common/warning.png`"
              :srcset="`${BaseUrl}assets/common/warning@2x.png`"
            />
            <!--  兩個頁籤 vue 共用此 modal  -->
            <slot name="head"></slot>
            <content>
              <slot name="content"></slot>
            </content>
          </div>
              <slot name="body"></slot>

          <div class="action text-right">
            <a v-if="closeBtn" @click="$emit('closeBtn')" class="btn btn-default w-120"
              >取消</a
            >
            <a @click="$emit('close')" class="btn btn-primary w-120">確定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "mvToOldPopup",
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    closeBtn: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: String,
      default: "",
    },
  },
  methods: {
  },
};
</script>